export default {
    dataIterator: {
        rowsPerPageText: 'Artículos por página:',
        rowsPerPageAll: 'Todos',
        pageText: '{0}-{1} di {2}',
        noResultsText: 'Sin resultado',
        nextPage: 'Pagina siguiente',
        prevPage: 'Pagina anterior'
    },
    dataTable: {
        rowsPerPageText: 'Líneas por página:'
    },
    noDataText: 'Sin resultado',
    generic: {
        executeLogin: "Iniciar sesión",
        newAccount: "Nuevo usuario? Registrarte",
        station_statues:{
            ready: "on-line",
            offline: "off-line",
            out_of_service: "fuera de servicio",
            maintenance: "mantenimiento"
        },
        bay_statues: {
            READY: "Listo",
            OUT_OF_SERVICE: "fuera de servicio",
            FAULTY: "Fuera de servicio"
        },
        bay_uses: {
            SHARING: "bike-sharing",
            PRIVATE: "recarga privada",
            CAR: "recarga de coche"
        },
        bay_usage_states: {
            PRELIEVO: "retirada",
            RICARICA: "recarga",
            RICONSEGNA: "entrega",
            NONE: "Ocupado"
        }
    },
    Login: {
        newAccount: "Nuevo usuario? Registrarte",
        lostPassword: "Contraseña olvidada",
        enter: "Inicio de sesión",
        loginSuccesfully: "Inicio de sesión exitoso!",
        loginSuccesfullyTitle: "ACCESO HECHO",
        errors: {
            unauthorized: "Nombre de usuario o contraseña incorrectos!",
            not_enabled: "Usuario no habilitado, revise su correo electrónico para confirmar su registro."
        }
    },
    ResetPassword: {
        usernamePlaceholder: "Nombre de usuario",
        emailPlaceholder: "Correo electrónico",
        resetPassword: "Recuperar Contraseña",
        successTitleReset: "SOLICITUD DE RESTAURAR CONTRASEÑA REALIZADA",
        successReset: "Solicitud de restablecimiento de contraseña enviada a su correo electrónico. Mire su correo electrónico y complete las operaciones",
        errors: {
            base: {
                no_user: "Cuenta no encontrada!",
                unexpected_error: "Error inesperado, comuníquese con la administración"
            }
        }
    },
    NewAccount: {
        mobilePhonePlaceholder: "Telefono movil *",
        smscodePlaceholder: "Còdigo SMS *",
        namePlaceholder: "Nombre *",
        surnamePlaceholder: "Apellido *",
        birthDatePlaceholder: "Fecha de nacimiento *",
        phonePlaceholder: "Número de celular *",
        emailPlaceholder: "Correo electrónico *",
        badgePlaceholder: "Tarjeta Electrónica",
        usernamePlaceholder: "Nombre de usuario *",
        passwordPlaceholder: "Contraseña *",
        passwordConfirmationPlaceholder: "Confirmar contraseña *",
        languagePlaceholder: "Idioma",
        residenceAddressPlaceholder: "Dirección de residencia *",
        residenceNumberPlaceholder: "Número de casa *",
        residenceCapPlaceholder: "Código postal *",
        residenceCityPlaceholder: "Residencia de la ciudad *",
        residenceDistrictPlaceholder: "Provincia de residencia *",
        residenceCountryPlaceholder: "País de residencia *",
        nationalIdentificationNumberPlaceholder: "Código fiscal",
        newUser: "NUEVO REGISTRO DE USUARIO",
        infoAccess: "Información de acceso",
        privacyConsent: "He leído la DECLARACIÓN DE PRIVACIDAD de conformidad con el reglamento de la UE 2016/679",
        regulationAcceptance: "Declaro que he leído y acepto el reglamento",
        Register: "Registrarte",
        subscribeSuccesfullyTitle: "Cuenta creada exitosamente!",
        subscribeSuccesfully: "Perfecto! Puedes comenzar a usar el servicio",
        titlePopupError: "Error de creación de cuenta",
        messagePopupError: "Algo salió mal. Inténtelo de nuevo!",
        successSubscription: "Cuenta creada con éxito.",
        closePopupPrivacy: "Cierra",
        closePopupRegulation: "Cierra",
        cell_verification_process: "Verifica el número de teléfono",
        check_phone_number: "Revisa el teléfono",
        sms_code_request: "Solicita el código",
        invalidPhoneNumber: "Número de teléfono inválido",
        invalidSmsCode: "Código inválido",
        errors: {
            lastname: {
                blank: "Campo obligatorio"
            },
            birth_date: {
                blank: "Campo obligatorio",
                should_be_adult: "no conforme"
            },
            email: {
                blank: "Campo obligatorio",
                invalid: "Formato de correo electrónico no válido"
            },
            username: {
                blank: "Campo obligatorio",
                taken: "Ya presente en el sistema"
            },
            password: {
                blank: "Campo obligatorio",
                invalid: "La contraseña debe tener al menos 10 caracteres y debe contener letras y números",
                must_same_password_confirm: "La contraseña y la confirmación de la contraseña deben coincidir"
            },
            password_confirmation: {
                blank: "Campo obligatorio",
                confirmation: "La contraseña y la confirmación de la contraseña deben coincidir"
            },
            gdpr_role: {
                inclusion: "Campo obligatorio"
            },
            regulation_acceptance: {
                inclusion: "Campo obligatorio"
            },
            national_identification_number: {
                taken: "Código fiscal ya presente en el sistema.",
                blank: "campo obligatorio",
                invalid_format: "formato incorrecto"
            },
            residence_address: {
                blank: "campo obligatorio"
            },
            residence_number: {
                blank: "campo obligatorio"
            },
            residence_cap: {
                blank: "campo obligatorio"
            },
            residence_city: {
                blank: "campo obligatorioo"
            },
            residence_district: {
                blank: "campo obligatorio"
            },
            residence_country: {
                blank: "campo obligatorio"
            }


        }

    },
    Application: {
        account: "Cuenta",
        statistics: "Estadísticas",
        logout: "Desloguearse",
        version: "Vers.",
        rules: "Reglamentos",
        closePopupRules: "Cierra"
    },
    PopUpStation: {
        goToStation: "Ir a la estación",
        close: "Cierra",
        tableData: {
            name: "Estación"
        },
        noResult: "Estación no encontrada"
    },
    StationInfo: {
        name: "Estación",
        availableVehicles: "Vehículos disponibles",
        totalCount: "Total lugares",
        freeBay: "Lugares libres",
        address: "Dirección"
    },
    Station: {
        loginToStation: "Acceder a la estacion",
        position: "Lugar",
        bayUsageBusyState: "Ocupado",
        availableFor: "Disponible para ",
        usages: {
            private: "Recarga privada de e-bikes",
            vehicle_private: "Recarga de vehículo eléctrico privado",
            sharing: "Recarga pública de e-bikes",
            car: "Recarga coche eléctrico",
            charger: "Lugar de recarga"
        }
    },
    BasePopUp: {
        close: "Cierra"
    },
    StationLogin: {
        warningMessage: "Atención!",
        message: "Ingrese el código de acceso que se muestra en la pantalla de la estación.",
        signIn: "Iniciar sesión",
        codePlaceholder: "Código de acceso",
        goodJobMessage: "Bien hecho!",
        messageSuccessLogin: "Has autenticado con éxito en la estación",
        messageSuccessLoginNoMonitorCode:"Te autenticaste correctamente, ahora utiliza el teclado de la columna",
        labelStation: "",
        instructions: "Continuar siguiendo las instrucciones en la pantalla de la estación ...",
        errorMessage: "El código ingresado es incorrecto y no corresponde al de la pantalla de la Estación. Por favor intente nuevamente haciendo clic en el siguiente botón ...",
        retry: "Inténtelo de nuevo"
    },
    Account: {
        editUser: "MODIFICACION DE USUARIO",
        editAccount: "Información de acceso",
        namePlaceholder: "Nombre *",
        birthDatePlaceholder: "Fecha de nacimiento *",
        surnamePlaceholder: "Apellido *",
        phonePlaceholder: "Número de celular",
        residenceAddressPlaceholder: "Dirección de residencia *",
        residenceNumberPlaceholder: "Número de casa *",
        residenceCapPlaceholder: "Código postal *",
        residenceCityPlaceholder: "Residencia de la ciudad *",
        residenceDistrictPlaceholder: "Provincia de residencia *",
        residenceCountryPlaceholder: "País de residencia *",
        nationalIdentificationNumberPlaceholder: "Código fiscal",
        badgePlaceholder: "Tarjeta Electrónica",
        emailPlaceholder: "Correo electrónico *",
        languagePlaceholder: "Idioma",
        update: "Actualiza",
        updateSuccesfullyTitle: "Bien hecho!",
        updateSuccesfully: "Información de cuenta actualizada correctamente.",
        confirmNewPasswordPlaceholder: "Confirmar contraseña *",
        newPasswordPlaceholder: "Nueva contraseña *",
        currentPasswordPlaceholder: "Actual contraseña *",
        updateSuccesfullyAccountTitle: "Bien hecho!",
        updateAccountSuccesfully: "Información de inicio de sesión actualizada",
        errors:{
            lastname:{
                blank: "campo obligatorio"
            },
            birth_date: {
                blank: "Campo obligatorio",
                should_be_adult: "no conforme"
            },
            email: {
                blank: "campo obligatorio"
            },
            password: {
                must_same_password_confirm: "La contraseña y la confirmación de la contraseña deben coincidir",
                blank: "campo obligatorio",
                invalid: "La contraseña debe tener al menos 10 caracteres y debe contener letras y números"
            },
            old_password: {
                unauthorized: "Contraseña actual incorrecta",
                blank: "Campo obligatorio"
            },
            password_confirmation: {
                blank: "Campo obligatorio",
                confirmation: "La contraseña y la confirmación de la contraseña deben coincidir"
            },
            residence_address: {
                blank: "campo obligatorio"
            },
            residence_number: {
                blank: "campo obligatorio"
            },
            residence_cap: {
                blank: "campo obligatorio"
            },
            residence_city: {
                blank: "campo obligatorio"
            },
            residence_district: {
                blank: "campo obligatorio"
            },
            residence_country: {
                blank: "campo obligatorio"
            },
            national_identification_number: {
                taken: "Código fiscal ya presente en el sistema",
                blank: "campo obligatorio",
                invalid_format: "formato incorrecto"
            }
        }

    },
    Statistics: {
        servicePlaceholder: "Servicio",
        dateFromPlaceholder: "De",
        dateToPlaceholder: "A",
        tableHeaders: {
            vehicle: "Vehículo"
        },
        services: {
            sharing_unit: "Bike-sharing",
            car_unit: "Recarga de coche eléctrico",
            recharge_unit: "Recarga de vehículo"
        },
        noResult: "Sin resultado",
        showMore: "Mostrar otros resultados"
    },
    NewPassword: {
        passwordPlaceholder: "Nueva contraseña",
        passwordConfirmationPlaceholder: "Confirmar nueva contraseña",
        noTokenError: "No se encontró el token de restablecimiento de contraseña",
        successPasswordChanged: "Ahora puedes iniciar sesión con tu nueva contraseña",
        successPasswordChangedTitle: "CONTRASEÑA CAMBIADA",
        changePassword: "Cambiar contraseña",
        errors: {
            password: {
                blank: "Campo obligatorio",
                invalid: "La contraseña debe tener al menos 10 caracteres y debe contener letras y números",
                must_same_password_confirm: "La contraseña y la confirmación de la contraseña deben coincidir"
            }
        }
    },
    AppUpgrade: {
        newUpdates: "Actualización",
        wouldYouUpgrade: "Una nueva versión está disponible, ¿quieres actualizar la aplicación?",
        update: "Actualizar",
        discardUpdate: "Cancelar"

    },
    AddToHome: {
        add: "Añadir",
        discardAdd: "Cancelar",
        installApp: "Instalar aplicación",
        installAppMessage: "Para una mejor experiencia, recomendamos agregar la aplicación a la pantalla de inicio",
        howToInstall: "Para una mejor experiencia, recomendamos agregar la aplicación a la pantalla de inicio",
        ok: "OK"

    },
    App: {
        offlineMessage: "Para utilizar la aplicación, se requiere una conexión a internet",
        offlineMessageTitle: "OPS! ESTAS FUERA DE LINEA"
    },
    Credit: {
        availableCredit: "BALANCE DISPONIBLE",
        rechargeCredit: "RECARGA DE CREDITO",
        paymentsArchive: "Archivo de pago",
        currency: "€",
        noPaymentMethodsMessage: "No es posible recargar su crédito porque no hay métodos de pago disponibles",
        noPaymentMethods: "SIN MÉTODO DE PAGO"
    },
    Braintree: {
        recharge: "Recargar",
        successPayment: "BIEN HECHO!",
        successPaymentMessage: "Pago exitoso",
        errorPayment: "ERROR!",
        errorPaymentMessage: "Error al procesar la solicitud de pago"
    },
    Stripe: {
        recharge: "Recargar",
        successPayment: "BIEN HECHO!",
        successPaymentMessage: "Pago exitoso",
        errorPayment: "ERROR!",
        errorPaymentMessage: "Error al procesar la solicitud de pago",
        waitingPayment: "ESPERAR",
        waitingPaymentMessage: "Procesando el pago...",
        unexpectedError: "Error inesperado",
        processingPayment: "Pago en curso"
    },
    Stations: {
        labelStation: "Estación",
        address: "Dirección",
        totalSeats: "Total lugares",
        availableSeats: "Lugares libres",
        availableVehicles: "Vehículos disponibles"

    },
    UpdateRequestedUserInfo: {
        warningMessage: "Complete su perfil de usuario con la información que falta"
    },

    languages: {
        "IT": "Italiano",
        "EN": "English",
        "ES": "Español",
        "DE": "Deutsch"
    },

    "CurrentSharing": {
      "duration": "Tiempo de uso",
      "startBay": "Estación de salida",
      "takeAt": "Fecha/hora de inicio de uso",
      "title": "Información de uso",
      "bike_lock": {
        "button": "DESBLOQUEAR CIERRE",
        "success_message": "Desbloqueo de cierre confirmado",
        "failure_message": "Desbloqueo fallido, por favor inténtelo de nuevo."
      }
    }

};